// import { Locale } from 'App/i18n' throws error we need to make a research the error
import { DomainTranslations } from 'App/i18n';
import { Locale } from 'App/i18n/enums';
import esAR from './common.es-AR.json';
import esMX from './common.es-MX.json';
import ptBR from './common.pt-BR.json';

const commonTranslations: DomainTranslations = {
  name: 'common',
  languages: {
    [Locale.ARGENTINA]: esAR,
    [Locale.MEXICO]: esMX,
    [Locale.BRAZIL]: ptBR,
  },
};

export default commonTranslations;
